import React from 'react'
import Calendar from 'react-calendar'

import './CustomCalendar.scss';

type CustomCalendarType = {
  //  value: any;
    onChange: (value: any) => void;
}

export default function CustomCalendar({onChange}:CustomCalendarType) {
    return (
        <Calendar
            // onChange={(val) => onChange} 
            onChange={onChange}
           //  value={value} 
            showDoubleView={true}
            selectRange={true}
        />
    )
}
